<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 margin-top-3 margin-bottom-3">
            <div class="w-100 d-inline-block text-center">
              <h1 class="half-black fw-bold filson-black-family text-uppercase 
              mb-0 text-full-32">
                Terms and Conditions
              </h1>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-3">
          <div class="col-12">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                Terms and Conditions
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                Welcome to Dubai Pets Groomer! These terms and conditions outline the rules and regulations for the use of our website and services.By accessing this website and/or booking our services, we assume you accept these terms and conditions. Do not continue to use Dubai Pets Groomer. if you do not agree to all of the terms and conditions stated on this page.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                1. Services
              </h2>
              <p class="mb-2 text-size-15 text-black family-inter-light text-full-15">
                1.1 Our pet grooming services include but are not limited to bathing, hair trimming, nail clipping, ear cleaning, and other services as agreed upon.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                1.2 We reserve the right to refuse service to any pet based on behavior, health concerns, or other reasons deemed necessary by our groomers.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                1.3 All services provided are subject to availability and scheduling.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                2. Bookings
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.1 Bookings for our services can be made online through our website or by contacting us directly.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.2 Changes or cancellations to bookings must be made at least 24 hours in advance. Failure to do so may result in a cancellation fee.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.3 We reserve the right to modify or cancel bookings due to unforeseen circumstances, such as emergencies or inclement weather.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                Information Sharing
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                We may share your information with third-party service providers who assist us in operating our website, conducting our business, or servicing you. These third parties are obligated to keep your information confidential and are prohibited from using your personal information for any other purpose.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                3. Payment
              </h2>
              <p class="mb-2 text-size-15 text-black family-inter-light text-full-15">
                3.1 Payment for services rendered is due at the time of service unless otherwise agreed upon.
              </p>
              <p class="mb-2 text-size-15 text-black family-inter-light text-full-15">
                3.2 We accept cash, credit/debit cards, and other forms of electronic payment.
              </p>
              <p class="mb-2 text-size-15 text-black family-inter-light text-full-15">
                3.3 Prices for our services are subject to change without notice. Any changes will be communicated to clients prior to service.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                4. Liability
              </h2>
              <p class="mb-2 text-size-15 text-black family-inter-light text-full-15">
                4.1 While we take every precaution to ensure the safety and well-being of all pets in our care, we cannot be held liable for any injuries, illnesses, or accidents that may occur.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                4.2 Owners are responsible for providing accurate information about their pets, including any known medical conditions or behavioral issues.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                4.3 Owners are responsible for any damages caused by their pets to our facilities, equipment, or personnel.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                5. Privacy
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                5.1 We respect the privacy of our clients and their pets. Any personal information collected will be used solely for the purpose of providing our services and will not be shared with third parties without consent.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                5.2 We may take photographs or videos of pets during grooming sessions for promotional purposes. Clients who do not wish for their pets to be photographed or filmed should inform us in advance.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                6. Governing Law
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                6.1 These terms and conditions are governed by and construed in accordance with the laws of Dubai.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold text-full-24 text-size-24 margin-bottom-3">
                7. Changes to Terms and Conditions
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                7.1 We reserve the right to update or modify these terms and conditions at any time without prior notice. Changes will be effective immediately upon posting to the website.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                7.2 By using our website and services, you agree to be bound by the most current version of these terms and conditions.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                7.3 If you have any questions or concerns about these terms and conditions, please contact us.
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                  <i class="fa fa-home nav-color" aria-hidden="true"></i>
                  Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                  Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'termsConditionBannerComponent',
}
</script>

<style scoped>
</style>
